<template>
  <div>
    <div class="py-2">
      <span><strong>Comparison usage</strong></span>
    </div>
    <VueApexCharts
      :options="lineAreaChart.options"
      :series="props.seriesData"
      height="350"
    ></VueApexCharts>
  </div>
</template>

<script setup>
import { reactive, defineProps } from "vue";
import VueApexCharts from "vue3-apexcharts";


const props = defineProps({
  seriesData: {
    type: Array,
    required: false,
    default: () => [],
  },
})

// * Bar Chart data
const lineAreaChart = reactive({
  options: {
    chart: {
      height: 350,
      type: "line",
      data: "dates",
      toolbar: {
        show: true,
      },
    },
    xaxis: {
      type: 'datetime',
      labels: {
        show: true,
        hideOverlappingLabels: true,
      }
    },
    stroke: {
      curve: "smooth",
      width: 2.5,
    },
    colors: ["#0c1e36", "#2b978d"],
    fill: {
      type: "solid",
      opacity: [1, 1],
    },
    markers: {
      size: 0,
    },
    yaxis: {
      labels: {
        show: true,
        formatter: function (val) {
          return val + " kWh";
        },
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
  },
});
</script>
